<template>
  <card>
    Student task list
  </card>
</template>

<script>
  import Breadcrumbs from "../../Layout/Breadcrumbs";

  import Spinner from "vue-spinner-component/src/Spinner";
  import {Table, TableColumn, Tooltip} from "element-ui";

  import {createNamespacedHelpers} from 'vuex';
  const {mapState, mapActions} = createNamespacedHelpers('student/tasks');

  export default {
    name: "StudentCourseTasks",
    metaInfo() {
      return {
        title: this.$i18n.t('My tasks')
      }
    },
    components: {
      Breadcrumbs,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Spinner
    },
    data() {
      return {
        waitFor: 'task list fetching'
      }
    },
    computed: {
      ...mapState({
        tasks: state => state.tasks
      }),
    },
    async created() {
      await this.fetchData();
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      ...mapActions({
        load: 'loadTasks',
      }),
      async fetchData() {
        this.$wait.start(this.waitFor);
        await this.load({urlParams: this.$route.params});
        this.$wait.end(this.waitFor);
      },
    }
  }
</script>

<style scoped>

</style>
